export const KOBOO_BLUE = '#0098BF';
export const KOBOO_LIGHT_BLUE = '#0098BF';
export const KOBOO_OTHER_BLUE = '#82BFCF';
export const KOBOO_LIGHT_OTHER_BLUE = '#9bd8e9';
export const KOBOO_GREY = '#A1A29E';
export const KOBOO_LIGHT_GREY = '#EEEEEE';
export const KOBOO_DARK_GREY = '#AEAEAC';
export const KOBOO_LIGHT_RED = '#F2BFBF';
export const KOBOO_RED_ERROR = '#e53b30';


// WEBPACK FOOTER //
// ./src/constants/colors.js